module.exports = __webpack_public_path__ + "resources/img/img-glassdome-omnibus.c2b1bb2eb1664e5bc6a4926de8c696bc.png";